/**
 * Created by Ning Jiang on 7/4/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap";
import {PPGameMode} from "../../gamemode/PPGameMode";
import {PixiesVsPiratesSoundConfig} from "../../PixiesVsPiratesSoundConfig";
import {BattleEvent} from "../../reelstoppresentation/battlecollect/BattleEvent";
import {IPixiesVsPiratesParsedServerData} from "../../server/parseddata/IPixiesVsPiratesParsedServerData";
import {PixiesVsPiratesParsedGameData} from "../../server/parseddata/PixiesVsPiratesParsedGameData";
import {PixiesVsPiratesParsedInitData} from "../../server/parseddata/PixiesVsPiratesParsedInitData";
import {BattleMeterView} from "./BattleMeterView";

export class BattleMeterController extends WinPresentationController {
    private _selectedCharacters:string[];
    private _view:BattleMeterView;
    private _playerSelection:number;
    private _pixieFSCount:number;
    private _pirateFSCount:number;
    private _currentPixieCount:number;
    private _currentPirateCount:number;
    private _battleCurrentWinner:string;
    private _currentMode:string;
    private _nextMode:string;
    private _timeline:TimelineLite | null;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "Meter", skippable : true});

        this._view = new BattleMeterView();
        this._selectedCharacters = ["NONE", "PIXIE", "PIRATE"];
        this._battleCurrentWinner = this._selectedCharacters[0];
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeMode(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, BattleEvent.SET_PLAYER_SELECTION, (event:GameEvent) => this.setPlaySelection(event.params[0]));
        EventHandler.addEventListener(this, BattleEvent.COLLECT_PIXIE, (event:GameEvent) => this.onCollectPixie());
        EventHandler.addEventListener(this, BattleEvent.COLLECT_PIRATE, (event:GameEvent) => this.onCollectPirate());
        EventHandler.addEventListener(this, BattleEvent.CHECK_COLLECT, (event:GameEvent) => this.checkCollect(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, BattleEvent.PLAY_DEFEAT, (event:GameEvent) => this.playDefeat());
    }

    private onChangeMode(data:IGameModeChangedData):void {
        if(data.newMode === GameMode.NORMAL) {
            this._view.hide();
        } else {
            this._currentPixieCount = 0;
            this._currentPirateCount = 0;
            this._view.init();
        }
        this._battleCurrentWinner = this._selectedCharacters[0];
        // this._currentPixieCount = 0;
        // this._currentPirateCount = 0;
        // this._view.init();
    }

    // do this because the meter receives collect data after changeMode.
    private setPlaySelection(selection:number):void {
        this._playerSelection = selection;
        this._view.setPlaySelection(this._playerSelection);
    }

    private onRestore():void {
        this._view.setMeterPosition(this._pixieFSCount, this._pirateFSCount);
        this._view.setCharsAnimStateOnRestore(this._pixieFSCount, this._pirateFSCount);
        this._battleCurrentWinner = this._selectedCharacters[this._pixieFSCount === this._pirateFSCount ? 0 : (this._pixieFSCount > this._pirateFSCount ? 1 : 2)];
        this._currentPixieCount = this._pixieFSCount;
        this._currentPirateCount = this._pirateFSCount;
    }

    private onDataParsed(data:IPixiesVsPiratesParsedServerData):void {
        this._pixieFSCount = data.pixieFSCount;
        this._pirateFSCount = data.pirateFSCount;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        if(data instanceof PixiesVsPiratesParsedInitData && data.isRestoreState) {
            this.setPlaySelection(data.playerFSSelection);
        }
    }

    protected parseFeatureGameData(data:PixiesVsPiratesParsedGameData):void {
        this._pixieFSCount = data.pixieFSCount;
        this._pirateFSCount = data.pirateFSCount;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._playerSelection = data.playerFSSelection;
    }

    private onCollectPixie():void {
        this._currentPixieCount++;
        this._view.setMeterPosition(this._currentPixieCount, this._currentPirateCount);
        this._view.playPixieCollected();
        // Logger.logDev(`BattleMeterController.onCollectPixie() pixies: ${this._currentPixieCount}, pirate: ${this._currentPirateCount}`);
    }

    private onCollectPirate():void {
        this._currentPirateCount++;
        this._view.setMeterPosition(this._currentPixieCount, this._currentPirateCount);
        this._view.playPirateCollected();
        // Logger.logDev(`BattleMeterController.onCollectPixie() pixies: ${this._currentPixieCount}, pirate: ${this._currentPirateCount}`);
    }

    private checkCollect(pixieCount:number, pirateCount:number):void {
        if(this._currentPixieCount != pixieCount || this._currentPirateCount != pirateCount) {
            debugger;
            Logger.logDev(`BattleMeterController.checkCollect(): collect amount doesn't match the end number pixie = ${pixieCount}, pirate = ${pirateCount}`);
            this._currentPixieCount = pixieCount;
            this._currentPirateCount = pirateCount;
            this._view.setMeterPosition(this._currentPixieCount, this._currentPirateCount);
        }
        // Logger.logDev(`BattleMeterController.checkCollect() pixies: ${this._currentPixieCount}, pirate: ${this._currentPirateCount}`);
    }

    private playDefeat():void {
        const draw:boolean = this._pixieFSCount === this._pirateFSCount;
        if(draw) {
            this._battleCurrentWinner = this._selectedCharacters[0];
            this._view.playDefeat(0);
            return;
        }

        const playWinnerIndex:number = this._pixieFSCount > this._pirateFSCount ? 1 : 2;
        const playWinner:string = this._selectedCharacters[playWinnerIndex];
        if(this._battleCurrentWinner != playWinner) {
            this._battleCurrentWinner = playWinner;
            SlotGame.sound.playEffect((<any>PixiesVsPiratesSoundConfig)[`FS_${playWinner}`]);
            this._view.playDefeat(playWinnerIndex);
        }
    }


    protected hasWin():boolean {
        return (this._currentMode === PPGameMode.FREESPIN && (this._nextMode === PPGameMode.FREESPIN_PICK || this._nextMode === PPGameMode.NORMAL));
    }

    protected startWinPresentation():void {
        const finalRoundUpTimeLine:TimelineLite = new TimelineLite({paused : true, onComplete : () => this.finish()});
        finalRoundUpTimeLine.add(this._view.animateFinalBattleStatus(this._pixieFSCount, this._pirateFSCount, this._playerSelection));
        this._timeline = finalRoundUpTimeLine;
        this._timeline.play();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
    }
}